import DefaultTemplate from './templates/default.jsx'

export default {
  default: DefaultTemplate
}
